class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    document.addEventListener(
      "DOMContentLoaded",
      function () {
        this?.handleRecommendedProducts();
      }.bind(this)
    );
  }

  handleRecommendedProducts() {
    const getRecommendedProducts = () => {
      const productRecommendationsSection = document.querySelector(
        ".product-recommendations-upsell"
      );

      const url = productRecommendationsSection?.dataset?.url;
      const productId = productRecommendationsSection?.dataset?.product;

      if (!productId) return;

      fetch(url)
        .then((response) => response?.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(
            ".product-recommendations"
          );
          if (recommendations && recommendations?.innerHTML?.trim()?.length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            const productRecommendationsBtns = document.querySelectorAll(
              ".product-recommendations-upsell .add-to-cart"
            );
            const sectionsToRender = [
              {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
              },
              {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".drawer__inner",
              },
            ];
            
            productRecommendationsBtns?.forEach((btn) => {
              btn?.addEventListener("click", function (e) {
                const id = e?.target?.dataset?.id;
                btn?.classList?.add("loading");
                const body = JSON.stringify({
                  items: [
                    {
                      id: id,
                      quantity: 1,
                    },
                  ],
                  sections: sectionsToRender?.map((section) => section.section),
                  sections_url: window.location.pathname,
                });
                fetch(window.Shopify.routes.root + "cart/add.js", {
                  ...fetchConfig(),
                  ...{ body },
                })
                  .then((response) => {
                    return response.text();
                  })
                  .then((state) => {
                    const parsedState = JSON.parse(state);
                    sectionsToRender.forEach((section) => {
                      const elementToReplace =
                        document
                          ?.getElementById(section?.id)
                          ?.querySelector(section?.selector) ||
                        document.getElementById(section?.id);

                      elementToReplace.innerHTML = new DOMParser()
                        .parseFromString(
                          parsedState.sections?.[section?.section],
                          "text/html"
                        )
                        .querySelector(section?.selector)?.innerHTML;
                      btn?.classList?.remove("loading");
                    });
                    btn?.classList?.remove("loading");
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "cart-items",
                      cartData: parsedState,
                    });
                  });
              });
            });

            if(!productRecommendationsBtns.length) {
              productRecommendationsSection.classList.add('hidden')
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const drawer = document?.querySelector(".drawer");

    const observerChange = new MutationObserver(function (mutations) {
      getRecommendedProducts();
      const drawerInner = document.querySelector(".drawer__inner");

      const observerDrawerInner = new MutationObserver(function (mutations) {
        getRecommendedProducts();
      });

      observerDrawerInner.observe(drawerInner, {
        attributes: true,
        childList: true,
        characterData: true,
      });

      if (!drawer?.classList?.contains("active")) {
        observerDrawerInner.disconnect();
      }
    });

    observerChange.observe(drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
